export const CONTENT_GROUP_ACTION = {
    OPEN_INVALID_STAGE_MODAL: 'OPEN_INVALID_STAGE_MODAL', // this action will be used for list and board tab
    CLOSE_INVALID_STAGE_MODAL: 'CLOSE_INVALID_STAGE_MODAL', // this action will be used for list and board tab
    OPEN_CARD_MODAL: 'OPEN_CARD_MODAL', 
    CLOSE_CARD_MODAL: 'CLOSE_CARD_MODAL', // this action will be used for list and board tab,
    SET_HIGHLIGHTED_COMMENT: 'SET_HIGHLIGHTED_COMMENT', // this action will be used for card popup
    UNSET_HIGHLIGHTED_COMMENT: 'UNSET_HIGHLIGHTED_COMMENT', // this action will be used for card popup
    DOWNLOADING_ATTACHMENT: 'DOWNLOADING_ATTACHMENT', // this action will be used for card popup
    DOWNLOADED_ATTACHMENT: 'DOWNLOADED_ATTACHMENT', // this action will be used for card popup

    UPDATE_UNREAD_COMMENTS: 'UPDATE_UNREAD_COMMENTS', // this action will be used for content group

    READ_TEAM_COMMENTS: 'READ_TEAM_COMMENTS', // this action will be performed before querying mark as read api
    READ_GUEST_COMMENTS: 'READ_GUEST_COMMENTS', // this action will be performed before querying mark as read api

    MINIMIZE_CARD: 'MINIMIZE_CARD', // this action will be used for card popup
    RESTORE_CARD: 'RESTORE_CARD', // this action will be used for card popup
    REMOVE_MINIMIZED_CARD: 'REMOVE_MINIMIZED_CARD', // this action will be used for card popup
    BULK_REMOVE_MINIMIZED_CARDS: 'BULK_REMOVE_MINIMIZED_CARDS', // this action will be used for card popup

    SET_AUTHORIZATIONS: 'SET_AUTHORIZATIONS', // this action will be used for card popup
    SET_ASSIGNED_USERS: 'SET_ASSIGNED_USERS', // this action will be used for card popup

    SET_MINIMIZED_CARDS: 'SET_MINIMIZED_CARDS', // this action will be used for fetching minimized cards   
    RESET_MINIMIZED_CARDS: 'RESET_MINIMIZED_CARDS', // this action will be used for resetting minimized cards 

    UPDATE_CONTENT_GROUP_POPUP: 'UPDATE_CONTENT_GROUP_POPUP', // this action will be used for updating content group popup data
    UPDATE_CONTENT_GROUP_ASSIGNED_USERS: 'UPDATE_CONTENT_GROUP_ASSIGNED_USERS', // this action will be used for updating content group assigned users data

    ADD_ATTACHMENTS_TO_CARD: 'ADD_ATTACHMENTS_TO_CARD', // this action will be used for adding attachments to content group popup data
    UPDATE_ATTACHMENTS_IN_CARD: 'UPDATE_ATTACHMENTS_IN_CARD', // this action will be used for updating attachments in content group popup data
    REMOVE_ATTACHMENTS_FROM_CARD: 'REMOVE_ATTACHMENTS_FROM_CARD', // this action will be used for removing attachments from content group popup data
    ADD_LABEL_TO_CARD: 'ADD_LABEL_TO_CARD', // this action will be used for adding label to content group popup data
    REMOVE_LABEL_FROM_CARD: 'REMOVE_LABEL_FROM_CARD', // this action will be used for removing label from content group popup data

    UPDATE_CARD_STAGE_INFO: 'UPDATE_CARD_STAGE_INFO',
    UPDATE_CARD_UNREAD_COMMENTS: 'UPDATE_CARD_UNREAD_COMMENTS',
    UPDATE_CARD_ITEM_AT_LIST: 'UPDATE_CARD_ITEM_AT_LIST',
    UPDATE_CARD_LIST_INFO: 'UPDATE_CARD_LIST_INFO',
};

export const CONTENT_GROUP_SETTINGS = {
    OPEN_CONTENT_GROUP_SETTINGS: 'OPEN_CONTENT_GROUP_SETTINGS',
    CLOSE_CONTENT_GROUP_SETTINGS: 'CLOSE_CONTENT_GROUP_SETTINGS',
}

export const CONTENT_GROUP_DUPLICATE = {
    OPEN_DUPLICATE_MODAL: 'OPEN_DUPLICATE_MODAL',
    CLOSE_DUPLICATE_MODAL: 'CLOSE_DUPLICATE_MODAL',

    CARD_DUPLICATE_REQUEST: 'CARD_DUPLICATE_REQUEST',
    CARD_DUPLICATE_SUCCESS: 'CARD_DUPLICATE_SUCCESS',
    CARD_DUPLICATE_FAILURE: 'CARD_DUPLICATE_FAILURE',
    CARD_DUPLICATE_RESET: 'CARD_DUPLICATE_RESET', 
    
    CARD_DUPLICATE_LOADING:  'CARD_DUPLICATE_LOADING',
    CARD_DUPLICATE_SET_SETTINGS: 'CARD_DUPLICATE_SET_SETTINGS',

    CARD_DUPLICATE_SET_STAGES: 'CARD_DUPLICATE_SET_STAGES',

    MAX_COPY: 5
}

export const CONTENT_GROUP_PARTICIPANTS = {
    OPEN_PARTICIPANTS_MODAL: 'OPEN_PARTICIPANTS_MODAL',
    CLOSE_PARTICIPANTS_MODAL: 'CLOSE_PARTICIPANTS_MODAL',
}



export const CONTENT_GROUP_DELETE = {
    OPEN_CARD_DELETE_MODAL: 'OPEN_CARD_DELETE_MODAL',
    CLOSE_CARD_DELETE_MODAL: 'CLOSE_CARD_DELETE_MODAL',
}

export const CONTENT_GROUP_VALUES ={}

export const CONTENT_GROUP_MESSAGE = {
    CONTENT_GROUP_TIME_TRACKED_EXIST: 'You have a card currently being time-tracked.',


    CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_TITLE: 'Move to Recycle Bin',
    CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_CONFIRM_TEXT: 'Move to Recycle Bin',
    CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_MESSAGE: 'This card will be permanently deleted after 30 days.'
};

export const CONTENT_GROUP_CALENDAR = {
    SET_CALENDAR_CARDS: 'SET_CALENDAR_CARDS',
    UPDATE_CALENDAR_CARD_DRAFT_STATUS: 'UPDATE_CALENDAR_CARD_DRAFT_STATUS',
    ADD_CALENDAR_CARDS: 'ADD_CALENDAR_CARDS',
    UPDATE_CALENDAR_CARD: 'UPDATE_CALENDAR_CARD',
    REMOVE_CALENDAR_CARD: 'REMOVE_CALENDAR_CARD',
    CLEAR_SHOULD_CLOSE_OVERLAY: 'CLEAR_SHOULD_CLOSE_OVERLAY',
}